import { Button, Layout, Panel } from "@mcleod/components";

export abstract class AutogenLayoutOfficePayrollToolPanel extends Layout {
    buttonUpdateStatuses: Button;
    panelButtons: Panel;
    panelOne: Panel;
    panelTwo: Panel;
}
